import gql from 'graphql-tag';

export const GET_FINANCE_PROGRAMS_OPTIONS = gql`
  query SubsidyCalculatorGetFinanceProgramsOptions($accountId: ID!) {
    options: financePrograms(accountId: $accountId) {
      value: financeProgramId
      label: nameInternal
    }
  }
`;
